import { ModelTypes } from "@zeus";
import { bindable } from "aurelia";

export class MediaHistoryCardComponent {
  @bindable media: ModelTypes['userMedia']
  @bindable reuseParams = () => Promise<void>
  private prompt: string
  private colorPalette: string
  private perspective: string
  private artisticStyle: string
  private aspectRatio: string

  attached() {
    const aiParams = JSON.parse(this.media.aiParameters)

    this.prompt = aiParams.prompt
    this.colorPalette = aiParams.colorPalette
    this.perspective = aiParams.perspective
    this.artisticStyle = aiParams.artisticStyle
    this.aspectRatio = aiParams.aspectRatio
  }

  get backgroundStyle() {
    return `background-image: url('https://uhgcmhbgmvuhtnaryxwr.storage.sa-east-1.nhost.run/v1/files/${this.media.fileId}')`;
  }
}